import {
  GET_PROVIDER_DETAIL,
  GET_PROVIDER_DETAIL_SUCCESS,
  GET_PROVIDER_DETAIL_FAILURE,
} from 'store/providerDetail/providerDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const providerDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_DETAIL:
      return { ...state, loading: true };
    case GET_PROVIDER_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PROVIDER_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default providerDetailReducer;
